export const ROUTES_NAMES = {
    user: {
        get: {
            me:`/me`,
            by_saaccount_name:(saAccountName: string)=>`/users?$count=true&$filter=startsWith(mail, '${saAccountName}')`
        }
    }
  }